import React from "react";
import { Layers } from "lucide-react";

function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-6xl px-4 ${className}`}>{children}</div>;
}

export default function MutualFunds() {
  return (
    <div className="min-h-screen bg-white">
      <Container className="py-10">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-950">
          <Layers className="h-4 w-4" />
          Mutual Funds
        </div>

        <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl text-slate-900">
          Curated mutual fund baskets by risk profile
        </h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          Keep it premium: show categories + explain selection logic clearly.
        </p>

        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {[
            { t: "Large Cap", d: "Stability-focused equity exposure." },
            { t: "Flexi Cap", d: "Dynamic allocation across market caps." },
            { t: "Mid/Small Cap", d: "Higher growth potential with higher volatility." },
            { t: "Hybrid", d: "Equity + debt mix for smoother ride." },
            { t: "Debt", d: "Lower volatility allocation for balance." },
            { t: "ELSS", d: "Tax saving with lock-in, suitable for long-term." },
          ].map((x) => (
            <div key={x.t} className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm">
              <div className="font-semibold text-slate-900">{x.t}</div>
              <div className="mt-2 text-sm text-slate-600">{x.d}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border border-emerald-900/10 bg-emerald-50/50 p-7">
          <div className="text-lg font-semibold text-slate-900">Selection logic (premium)</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            <li>• Consistency across market cycles</li>
            <li>• Risk-adjusted performance</li>
            <li>• Expense ratio awareness</li>
            <li>• Diversification across categories</li>
            <li>• Periodic review and rebalancing</li>
          </ul>
        </div>

        <p className="mt-6 text-xs text-slate-500">
          Compliance note: Avoid showing “guaranteed returns”. Use “expected/estimated” language.
        </p>
      </Container>
    </div>
  );
}
